import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * Responsive card grid: 1 column on mobile, 2 at `sm`, 3 at `lg`.
 * A child can span wider with a col-span utility (e.g. `sm:col-span-2`) — used
 * for the featured card.
 */
export function CardGrid({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('grid grid-cols-1 gap-grid sm:grid-cols-2 lg:grid-cols-3', className)}>
      {children}
    </div>
  )
}
